import { SubscriptionActionTypes } from './subscription.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    subscriptionListSuccess: null,
    subscriptionListError: null,
    addSubscriptionSuccess: null,
    addSubscriptionError: null,
    addSubscriptionReqStatus: '',
    updateSubscriptionSuccess: null,
    updateSubscriptionError: null,
    updateSubscriptionReqStatus: '',
    updateSubscriptionStatusSuccess: null,
    updateSubscriptionStatusError: null,
    updateSubscriptionStatusReqStatus: '',
    updateTransactionStatusSuccess: null,
    updateTransactionStatusError: null,
    updateTransactionStatusReqStatus: '',
    newTransactionSuccess: null,
    newTransactionError: null,
    newTransactionReqStatus: ''
}

const subscriptionReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SubscriptionActionTypes.SUBSCRIPTION_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                subscriptionListSuccess: action.payload,
                subscriptionListError: null
            }
        case SubscriptionActionTypes.SUBSCRIPTION_LIST_REQUEST_ERROR:
            return {
                ...state,
                subscriptionListSuccess: null,
                subscriptionListError: action.payload
            }
        case SubscriptionActionTypes.ADD_SUBSCRIPTION_REQUEST_SUCCESS:
            return {
                ...state,
                addSubscriptionSuccess: action.payload,
                addSubscriptionError: null,
                addSubscriptionReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SubscriptionActionTypes.ADD_SUBSCRIPTION_REQUEST_ERROR:
            return {
                ...state,
                addSubscriptionSuccess: null,
                addSubscriptionError: action.payload,
                addSubscriptionReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SubscriptionActionTypes.ADD_SUBSCRIPTION_REQUEST_STATUS:
            return {
                ...state,
                addSubscriptionReqStatus: ''
            }
        case SubscriptionActionTypes.UPDATE_SUBSCRIPTION_REQUEST_SUCCESS:
            return {
                ...state,
                updateSubscriptionSuccess: action.payload,
                updateSubscriptionError: null,
                updateSubscriptionReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SubscriptionActionTypes.UPDATE_SUBSCRIPTION_REQUEST_ERROR:
            return {
                ...state,
                updateSubscriptionSuccess: null,
                updateSubscriptionError: action.payload,
                updateSubscriptionReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SubscriptionActionTypes.UPDATE_SUBSCRIPTION_REQUEST_STATUS:
            return {
                ...state,
                updateSubscriptionReqStatus: ''
            }
        case SubscriptionActionTypes.UPDATE_SUBSCRIPTION_STATUS_REQUEST_SUCCESS:
            return {
                ...state,
                updateSubscriptionStatusSuccess: action.payload,
                updateSubscriptionStatusError: null,
                updateSubscriptionStatusReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SubscriptionActionTypes.UPDATE_SUBSCRIPTION_STATUS_REQUEST_ERROR:
            return {
                ...state,
                updateSubscriptionStatusSuccess: null,
                updateSubscriptionStatusError: action.payload,
                updateSubscriptionStatusReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SubscriptionActionTypes.UPDATE_SUBSCRIPTION_STATUS_REQUEST_STATUS:
            return {
                ...state,
                updateSubscriptionStatusReqStatus: ''
            }
        case SubscriptionActionTypes.UPDATE_TRANSACTION_STATUS_REQUEST_SUCCESS:
            return {
                ...state,
                updateTransactionStatusSuccess: action.payload,
                updateTransactionStatusError: null,
                updateTransactionStatusReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SubscriptionActionTypes.UPDATE_TRANSACTION_STATUS_REQUEST_ERROR:
            return {
                ...state,
                updateTransactionStatusSuccess: null,
                updateTransactionStatusError: action.payload,
                updateTransactionStatusReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SubscriptionActionTypes.UPDATE_TRANSACTION_STATUS_REQUEST_STATUS:
            return {
                ...state,
                updateTransactionStatusReqStatus: ''
            }
        case SubscriptionActionTypes.NEW_TRANSACTION_REQUEST_SUCCESS:
            return {
                ...state,
                newTransactionSuccess: action.payload,
                newTransactionError: null,
                newTransactionReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case SubscriptionActionTypes.NEW_TRANSACTION_REQUEST_ERROR:
            return {
                ...state,
                newTransactionSuccess: null,
                newTransactionError: action.payload,
                newTransactionReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case SubscriptionActionTypes.NEW_TRANSACTION_REQUEST_STATUS:
            return {
                ...state,
                newTransactionReqStatus: ''
            }
        case SubscriptionActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default subscriptionReducer